import React from 'react';

import {
  Colors,
  Icon,
  type IconProps,
  Typography,
  createClasses,
  spacing,
} from '@kp/react-ui';

const classes = createClasses({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: spacing('xs'),
    minWidth: 0,
  },
  icon: {
    color: Colors.Neutral.icon,
    flexShrink: 0,
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing('xs'),
    minWidth: 0,
  },
  title: {
    margin: 0,
    color: Colors.Neutral.text,
  },
  subtitle: {
    color: Colors.Neutral.textInactive,
  },
});

export interface KpiCardHeaderProps {
  icon?: IconProps['icon'];
  title: string;
  subtitle: string;
}

export const KpiCardHeader: React.FC<KpiCardHeaderProps> = ({
  icon,
  title,
  subtitle,
}) => (
  <div className={classes.root}>
    {icon && <Icon icon={icon} size={20} className={classes.icon} />}
    <div className={classes.text}>
      <Typography
        variant="labelMedium"
        component="h3"
        className={classes.title}
      >
        {title}
      </Typography>
      <Typography variant="bodySmall" className={classes.subtitle}>
        {subtitle}
      </Typography>
    </div>
  </div>
);
